export const APPEARANCE_MODE_LIGHT = 'LIGHT' as const;
export const APPEARANCE_MODE_DARK = 'DARK' as const;

export const APPEARANCE_ENUMS = [APPEARANCE_MODE_LIGHT, APPEARANCE_MODE_DARK] as const;

export const SPACING = 4 as const;

export const VARIANT_TEXT = 'text' as const;
export const VARIANT_OUTLINED = 'outlined' as const;
export const VARIANT_FILLED = 'filled' as const;
export const VARIANT_CONTAINED = 'contained' as const;

export const SHAPE_SQUARE = 'square' as const;
export const SHAPE_ROUNDED = 'rounded' as const;
export const SHAPE_CIRCULAR = 'circular' as const;

export const SIZE_X_SMALL = 'xSmall' as const;
export const SIZE_SMALL = 'small' as const;
export const SIZE_MEDIUM = 'medium' as const;
export const SIZE_LARGE = 'large' as const;
export const SIZE_X_LARGE = 'xLarge' as const;
